// import Vue from 'vue';
import dayjs from 'dayjs';
const utc = require('dayjs/plugin/utc')
const customParseFormat = require("dayjs/plugin/customParseFormat");

dayjs.extend(customParseFormat);
dayjs.extend(utc)

// import relativeTime from 'dayjs/plugin/relativeTime';
// dayjs.extend(relativeTime);

export default {
  install: function(Vue,) {
    Object.defineProperties(Vue.prototype, {
      $date: {
        get() {
          return dayjs
        }
      },
      $dayjs: {
        get() {
          return dayjs
        }
      }
    });
  }
}



